import type { RefetchFieldsReturn } from './index';

export const isFieldInResponse = ({
	fieldId,
	response,
}: {
	fieldId: string;
	response: RefetchFieldsReturn[0];
}) => {
	const field = (response.data.jiraBusinessAvailableFields?.edges ?? []).find((issueTypeEdge) =>
		issueTypeEdge?.node?.fields?.edges?.find((fieldEdge) => fieldEdge?.node?.fieldId === fieldId),
	);
	return !!field;
};
